import script from "./AbnahmeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AbnahmeView.vue?vue&type=script&setup=true&lang=ts"

import "./AbnahmeView.vue?vue&type=style&index=0&id=45e00b18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45e00b18"]])

export default __exports__